<template>
  <v-form v-model="check">
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span v-if="!!id">Изменить организацию</span>
              <span v-else> <div>Добавить организацию</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text v-if="lang.length > 0">

            <v-card-text class = "text-xs-left subheading">
              Наименование:
            </v-card-text>
            <div  v-for="item, i in value.name">
              <v-text-field
                :error="hasError('name')"
                :error-messages="getError('name')"
                :label= findLang(value.name[i].language)
                required
                v-model="value.name[i].text"
              ></v-text-field>
            </div>
            <v-alert
              :value="hasError('detail')"
              type="error"
            >
              {{getError('detail')}}
            </v-alert>
            <v-btn @click="apply" color="primary">Сохранить</v-btn>
          </v-card-text>
          <v-progress-circular v-else class="mt-3"
                               :size="70"
                               color="primary"
                               indeterminate
          />
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
    // import urls from "../../../../../urls"
    import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
    import {makeGetRequest} from "../../../../../helper";

    export default {
        name: "Organization",
        mixins: [UserDataFormMixin],
        props: {
            id: Number,
            name: Array,
        },

        data() {
            return {
                check: true,
                URL_CREATE: process.env.VUE_APP_API_HOST +"council/admin/core/models/organization/",
                URL_UPDATE:  process.env.VUE_APP_API_HOST +"council/admin/core/models/organization/<id>/",
                lang: [],
                value: {
                    id: this.id || '',
                    name: this.name || [],
                },

            }
        },
        methods: {
            findLang(langid){
                let str = this.lang.find(x => x.id === langid).name;
                return str
            },
            closeDialog() {
                this.$emit('ended', '')
            },
        },
        created() {
            let url =  process.env.VUE_APP_API_HOST +"council/admin/core/models/language/"
            let sys = true
            makeGetRequest(url).then(resp => {
                if (!resp.ok) {
                    sys = false
                }
                return resp.json()
            }) .then(json => {
                this.lang = json

                if(this.value.name.length === 0){
                    for (let key in this.lang) {
                        let keylang = (this.lang[key].id)
                        this.value.name.push({"text":"","language":keylang})
                    }
                }else if(this.value.name.length !== this.lang.length){
                    //если добавили новый предмет и редактируем
                    for (let key in this.lang) {
                        let answ = this.value.name.find(x => x.language === this.lang[key].id );
                        if (answ === undefined){
                            this.value.name.push({"text":"","language": this.lang[key].id})
                        }
                    }
                }


            })
        }
    }

</script>

<style scoped>

</style>
